import { PageHeader } from '@shared/components';

import { AdminExamLocationManagementNavigationTabs } from '../admin-exam-location-management-navigation-tabs';

export default function AdminExamLocationManagementHeader() {
  return (
    <PageHeader title='จัดการสถานที่สอบ' tabs={<AdminExamLocationManagementNavigationTabs />} />
  );
}
